export const isHttpError = (error: unknown, status?: number): boolean => {
  if (
    !(
      error instanceof Error &&
      'response' in error &&
      typeof error.response === 'object' &&
      error.response !== null &&
      'status' in error.response &&
      typeof error.response.status === 'number'
    )
  ) {
    return false;
  }

  if (status === undefined) {
    return true;
  }

  return error.response.status === status;
};
